/* @flow */

import { type ContextRouter } from 'react-router-dom';
import * as React from 'react';

import RankingPage from '../../common/RankingPage';

const PizzaRankingPage = (props: ContextRouter) => (
  <RankingPage
    kind="pizza"
    onNextClick={() => {
      props.history.push('/pizza/fields?skip_intro=1');
    }}
  />
);

export default PizzaRankingPage;
